import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  Output,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

export type PssConfirmModalVariant = 'danger' | 'warning';

@Component({
  selector: 'app-pss-confirm-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './pss-confirm-modal.component.html',
  styleUrl: './pss-confirm-modal.component.css',
})
export class PssConfirmModalComponent implements AfterViewInit, OnDestroy {
  @Input() title = 'ยืนยันการดำเนินการ?';
  @Input() message = '';
  @Input() highlight = '';
  @Input() messageSuffix = '';
  @Input() confirmLabel = 'ยืนยัน';
  @Input() cancelLabel = 'ยกเลิก';
  @Input() variant: PssConfirmModalVariant = 'danger';
  @Input() icon = 'delete_forever';
  @Input() showIrreversibleNote = true;
  @Input() loading = false;
  @Input() loadingLabel = 'กำลังดำเนินการ...';
  /** When true, user must enter remark before confirm is allowed. */
  @Input() requireRemark = false;
  @Input() remarkLabel = 'หมายเหตุ (Remark)';
  @Input() remarkPlaceholder = 'กรุณาระบุเหตุผลการลบ / ยกเลิก';
  @Input() remark = '';
  @Output() remarkChange = new EventEmitter<string>();

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  get canConfirm(): boolean {
    if (this.loading) return false;
    if (!this.requireRemark) return true;
    return !!this.remark?.trim();
  }

  onRemarkInput(value: string): void {
    this.remark = value;
    this.remarkChange.emit(value);
  }

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.renderer.appendChild(this.document.body, this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const parent = this.elementRef.nativeElement.parentNode;
    if (parent) {
      this.renderer.removeChild(parent, this.elementRef.nativeElement);
    }
  }

  onCancel(): void {
    if (this.loading) return;
    this.cancel.emit();
  }

  onConfirm(): void {
    if (!this.canConfirm) return;
    this.confirm.emit();
  }
}
